import { render, staticRenderFns } from "./GlobalSearchHeader.vue?vue&type=template&id=5c444c76&"
import script from "./GlobalSearchHeader.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c444c76')) {
      api.createRecord('5c444c76', component.options)
    } else {
      api.reload('5c444c76', component.options)
    }
    module.hot.accept("./GlobalSearchHeader.vue?vue&type=template&id=5c444c76&", function () {
      api.rerender('5c444c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/GlobalSearchHeader.vue"
export default component.exports